import { AirdropSelectAmountPageTemplate } from "./template";
import { useAirdropSelectAmountPage } from "./logic";

export const AirdropSelectAmountPage = (): JSX.Element => {
    const props = useAirdropSelectAmountPage();
    return (
        <AirdropSelectAmountPageTemplate {...props} />
    )
}